import React from "react";
import { Box } from "@mui/material";
import { dt } from "../../../../shared/themes/redesignTokens";
import useTranslation from "../../../../shared/hooks/useTranslation";

interface OfferMessageCardProps {
  message?: string;
}

const OfferMessageCard: React.FC<OfferMessageCardProps> = ({ message }) => {
  const { translate } = useTranslation(["serviceOffers"]);

  if (!message) return null;

  return (
    <Box
      sx={{
        backgroundColor: dt.cardBg,
        border: `1px solid ${dt.cardBorder}`,
        borderRadius: dt.radius,
        padding: "20px",
      }}
    >
      <Box
        sx={{
          fontSize: "11px",
          fontWeight: 700,
          textTransform: "uppercase",
          letterSpacing: "1px",
          color: dt.textMuted,
          fontFamily: dt.font,
          mb: "12px",
        }}
      >
        {translate("messageToCustomer")}
      </Box>
      <Box
        sx={{
          fontSize: "14px",
          fontFamily: dt.font,
          color: dt.textPrimary,
          whiteSpace: "pre-wrap",
          lineHeight: 1.6,
        }}
      >
        {message}
      </Box>
    </Box>
  );
};

export default OfferMessageCard;
